import React from 'react'
import {Button, Col, Container, Row} from 'react-bootstrap'
import 'moment-timezone'
import AnswerResultDetails from './AnswerResultDetails.js'

const AdminResultDetailsList = ({answers, handleBackButton}) => {
    const handlePrint = (e) => {
        e.preventDefault()
        window.print()
    }

    return (
        <>
            <Container
                className="d-print-none mb-1 py-1"
                style={{
                    backgroundColor: 'white',
                    boxShadow: '0 0 5px 0.1px #ccc',
                    borderRadius: '5px'
                }}
            >
                <Row className="justify-content-md-center">
                    <Col xs={12} md={11}>
                        <Row>
                            <Col className="text-left m-0 p-0">
                                <Button
                                    type="button"
                                    variant="link"
                                    onClick={handleBackButton}
                                    className="d-print-none p-0"
                                >
                                    <i className="fa fa-arrow-left"></i> Voltar
                                </Button>
                            </Col>
                            <Col className="text-right m-0 p-0">
                                <Button
                                    type="button"
                                    variant="link"
                                    onClick={handlePrint}
                                    className="d-print-none p-0"
                                >
                                    <i className="fas fa-print"></i> Imprimir
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            <style>
                {`@media print {
                    .page-break {
                        page-break-after: always;
                        break-after: page;
                    }
                }`}
            </style>
            {answers.map((answer, index) =>
                <Row
                    key={answer.id}
                    className={index < answers.length - 1 ? 'page-break mb-2' : ''}
                >
                    <Col>
                        <AnswerResultDetails answer={answer} hidePrintButton/>
                    </Col>
                </Row>
            )}
        </>
    )
}

export default AdminResultDetailsList
